import React, { useState } from 'react';
import { useMutation, useQueryClient, useQuery } from '@tanstack/react-query';
import { createMember } from '../../api/members';
import api from '../../api/client';
import Modal from '../ui/Modal';
import FormField, { Input, Select, FormRow, SubmitBtn } from '../ui/FormField';
import toast from 'react-hot-toast';

export default function AddMemberModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const qc = useQueryClient();
  const [form, setForm] = useState({ first_name:'', last_name:'', email:'', phone:'', barcode:'', member_type_id:'' });
  const [loading, setLoading] = useState(false);

  const { data: types } = useQuery({ queryKey: ['member-types'], queryFn: () => api.get('/members/types') } as any);
  const set = (k: string) => (e: any) => setForm(f => ({...f, [k]: e.target.value}));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.first_name || !form.last_name) return toast.error('სახელი და გვარი სავალდებულოა');
    setLoading(true);
    try {
      await createMember(form);
      toast.success('წევრი დაემატა!');
      qc.invalidateQueries({ queryKey: ['members'] });
      qc.invalidateQueries({ queryKey: ['stats'] });
      setForm({ first_name:'', last_name:'', email:'', phone:'', barcode:'', member_type_id:'' });
      onClose();
    } catch { toast.error('შეცდომა'); }
    finally { setLoading(false); }
  };

  return (
    <Modal open={open} onClose={onClose} title="წევრის დამატება" width={480}>
      <form onSubmit={handleSubmit}>
        <FormRow>
          <FormField label="სახელი" required>
            <Input value={form.first_name} onChange={set('first_name')} placeholder="სახელი" />
          </FormField>
          <FormField label="გვარი" required>
            <Input value={form.last_name} onChange={set('last_name')} placeholder="გვარი" />
          </FormField>
        </FormRow>
        <FormField label="ელ-ფოსტა">
          <Input type="email" value={form.email} onChange={set('email')} placeholder="mail@example.com" />
        </FormField>
        <FormRow>
          <FormField label="ტელეფონი">
            <Input value={form.phone} onChange={set('phone')} placeholder="+995 5xx xxx xxx" />
          </FormField>
          <FormField label="ბარკოდი">
            <Input value={form.barcode} onChange={set('barcode')} placeholder="უნიკალური კოდი" />
          </FormField>
        </FormRow>
        <FormField label="ტიპი">
          <Select value={form.member_type_id} onChange={set('member_type_id')}>
            <option value="">— ტიპი —</option>
            {((types as any)?.data?.types||[]).map((t: any) => (
              <option key={t.id} value={t.id}>{t.name}</option>
            ))}
          </Select>
        </FormField>
        <SubmitBtn loading={loading} label="დამატება" />
      </form>
    </Modal>
  );
}
